import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetFooterParams } from "../interface";
import LandingFooter from "design-system/src/Components/WidgetPart/LandingFooter/LandingFooter";
import usePageLang from "@src/hooks/usePageLang";
import useNavigationUrlFactory from "@src/hooks/useNavigationUrlFactory";
import { AvailableLanguage } from "design-system/src/Interface/logoLang";

const LandingStandardFooter: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetFooterParams>((props) => {
    const { p } = props;
    const logoSource = p("logo_source") || "image";
    const lang = usePageLang();
    const routes = useNavigationUrlFactory();

    return (
      <LandingFooter
        lang={lang as AvailableLanguage}
        logoId={p("logo")}
        logoSource={logoSource}
        svgLogo={p("svg_logo")}
        logoLink={routes.home()}
        title={p("share_title") || ""}
        hashtag={p("hashtag")}
        socialNetworkLabel={p("social_text")}
        socialLinks={{
          facebook: p("facebook_link"),
          instagram: p("instagram_link"),
          pinterest: p("pinterest_link"),
          tiktok: p("tiktok_link"),
        }}
        footerText={p("footer_text")}
        backgroundImage={{
          desktop: p("background_media_desktop"),
          mobile: p("background_media_mobile"),
        }}
      />
    );
  });

export default LandingStandardFooter;
